import { useMutation } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import type { CredentialVaultScope } from "../lib/credential-vault-scope";

export function useCredentialVaultDocumentMutations(
  scope: CredentialVaultScope,
) {
  const trpc = useTRPC();
  const providerDelete = useMutation(
    trpc.credentials.deleteMyReviewUpload.mutationOptions(),
  );
  const orgDelete = useMutation(
    trpc.credentials.deleteReviewUploadForBu.mutationOptions(),
  );
  const providerRemove = useMutation(
    trpc.credentials.removeMyDocument.mutationOptions(),
  );
  const orgRemove = useMutation(
    trpc.credentials.removeDocumentForBu.mutationOptions(),
  );

  function deleteUpload(documentId: string) {
    if (scope.kind === "organization") {
      return orgDelete.mutateAsync({
        organizationBusinessUnitId: scope.organizationBusinessUnitId,
        providerUserId: scope.providerUserId,
        ...(scope.expectedAffiliationId
          ? { expectedAffiliationId: scope.expectedAffiliationId }
          : {}),
        documentId,
      });
    }
    return providerDelete.mutateAsync({
      switchUserId: scope.userId,
      documentId,
    });
  }
  function removeDocument(input: { credentialId: string; documentId: string }) {
    if (scope.kind === "organization") {
      return orgRemove.mutateAsync({
        ...input,
        organizationBusinessUnitId: scope.organizationBusinessUnitId,
        providerUserId: scope.providerUserId,
        ...(scope.expectedAffiliationId
          ? { expectedAffiliationId: scope.expectedAffiliationId }
          : {}),
      });
    }
    return providerRemove.mutateAsync({ ...input, switchUserId: scope.userId });
  }
  const activeDelete =
    scope.kind === "organization" ? orgDelete : providerDelete;
  return {
    deleteUpload,
    removeDocument,
    isDeleting: providerDelete.isPending || orgDelete.isPending,
    isRemoving: providerRemove.isPending || orgRemove.isPending,
    deletingDocumentId: activeDelete.isPending
      ? activeDelete.variables?.documentId
      : null,
  };
}
